import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isOpenInq: false,
  projects_full_list_detail: [],
  countryList: [],
  thankyouData: {
    page_name: '',
    document: []
  }
}

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setIsOpenInq(state, action) {
      state.isOpenInq = action.payload
    },
    setProjectsFullListDetail(state, action) {
      state.projects_full_list_detail = action.payload
    },
    setCountryList(state, action) {
      state.countryList = action.payload
    },
    setThankYouData(state, action) {
      state.thankyouData = action.payload
    },
    clearThankYouData(state) {
      state.thankyouData = initialState.thankyouData
    }
  }
})

export const {
  setIsOpenInq,
  setProjectsFullListDetail,
  setCountryList,
  setThankYouData,
  clearThankYouData
} = projectSlice.actions
export default projectSlice.reducer
